import React, { FC } from 'react';
import AniComp from './index';

// const Product: FC = () => {
//     return <AniComp />;
// };

export default AniComp;
